export default "/assets/in-line-d30cc596c6985440e2cd21c38855f9d7958f136bc4a58627e5c8d6a8abe957ef.svg";